/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/Log";

export function getAll(orderId) {
  return APIClient.get(`${endpoint}/${orderId}`);
}
